module.exports = __webpack_public_path__ + "img/bill (1).94deec59.svg";